import { ShieldAlert, CloudOff, Scale, KeyRound } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { useLanguage } from "@/hooks/useLanguage";

const icons = [ShieldAlert, CloudOff, Scale, KeyRound];

const OnPremiseChallengesSection = () => {
  const { ref, isVisible } = useScrollAnimation();
  const { t, tObject } = useLanguage();
  const items = tObject<Array<{ title: string; description: string }>>("onPremisePage.challenges.items");

  return (
    <section ref={ref} className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <p className="text-chathero-orange font-semibold text-sm mb-3">{t("onPremisePage.challenges.badge")}</p>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            {t("onPremisePage.challenges.title")}
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {t("onPremisePage.challenges.intro")}
          </p>
        </div>

        <div className={`grid md:grid-cols-2 gap-8 max-w-4xl mx-auto transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {items.map((item, index) => {
            const Icon = icons[index] || ShieldAlert;
            return (
              <div
                key={index}
                className="bg-background border border-border rounded-2xl p-8 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-12 h-12 rounded-xl bg-destructive/10 flex items-center justify-center mb-4">
                  <Icon className="w-6 h-6 text-destructive" />
                </div>
                <h3 className="text-xl font-bold text-foreground mb-2">{item.title}</h3>
                <p className="text-muted-foreground leading-relaxed">{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OnPremiseChallengesSection;
